import { ruleRunner } from 'validations/ruleRunner';
import { arrayMinLength } from 'validations/rules';

const Validations = [ruleRunner('coproducers', 'parceiros', arrayMinLength(1))];

export default Validations;
